import { uid } from 'uid';

export const cacheTags = {
  balance: uid(),
  account: uid(),
  chainData: uid(),
  taskData: uid(),
};
